import React from "react"
import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"
import { ChildSelector } from "../helpers/ChildSelector"
import * as skillsOverviewRightStyles from "../styles/SkillsOverviewCardRight.module.css"

export default function SkillsOverviewCardRight(props) {
  const { content } = props

  const mainTitle = ChildSelector.select(
    content,
    `skills-overview-main-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const title = ChildSelector.select(
    content,
    `skills-overview-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subTitle = ChildSelector.select(
    content,
    `skills-overview-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const contentPart1 = ChildSelector.select(
    content,
    `skills-overview-content`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(c => c.innerHTML)

  const contentPart2 = ChildSelector.select(
    content,
    `skills-overview-content-part-2`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(c => c.innerHTML)

  const contentBullets = ChildSelector.select(
    content,
    `skills-overview-list`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(c => c.innerHTML)

  return (
    <div
      className={`row ${props.className} ${skillsOverviewRightStyles.wrapper}`}
    >
      {mainTitle && (
        <div
          className={`col-12 g-0 ${skillsOverviewRightStyles.mainTitleContainer}`}
        >
          <h1
            className={skillsOverviewRightStyles.mainTitle}
            dangerouslySetInnerHTML={{
              __html: mainTitle,
            }}
          />
        </div>
      )}

      <TwoColumnHeroWithImageRight
        contentClass={skillsOverviewRightStyles.content}
        imageHolder={content}
        imageSelector={`skills-overview-media`}
        imageClass={skillsOverviewRightStyles.backgroundImage}
        className={skillsOverviewRightStyles.contentWrapper}
        mode={CONTAINMENT_MODE.normal}
      >
        <div className={` ${skillsOverviewRightStyles.textContent}`}>
          <h2
            className={skillsOverviewRightStyles.title}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />

          {subTitle && (
            <h3
              className={skillsOverviewRightStyles.subTitle}
              dangerouslySetInnerHTML={{
                __html: subTitle,
              }}
            />
          )}

          {contentPart1 &&
            contentPart1.map(p => (
              <p
                className={skillsOverviewRightStyles.textcontent}
                dangerouslySetInnerHTML={{
                  __html: p,
                }}
              />
            ))}

          {contentBullets && contentBullets.map(b => (
            <ul
              className={skillsOverviewRightStyles.list}
                dangerouslySetInnerHTML={{
                  __html: b,
                }}
              />
            ))}
          {contentPart2 &&
            contentPart2.map(p => (
              <p
                className={skillsOverviewRightStyles.textContent}
                dangerouslySetInnerHTML={{
                  __html: p,
                }}
              />
            ))}
        </div>
      </TwoColumnHeroWithImageRight>
    </div>
  )
}
